// extracted by mini-css-extract-plugin
export default {"container":"ModuleLocked_container__g8F22"};